import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'

import stylesTagField from '../../../struct/TagSourceField.less'
import styles from './FieldMappingSettings.less'
import {observer} from "mobx-react";
import InputText from 'lib/control/InputText';
import {IS_EMPTY, SPECIFIC} from '../../../../constant/ValueSourceType';
import OfferFieldValueSourceSelect from '../../../profile_settings/offer/field_mapping/OfferFieldValueSourceSelect';

import Icon from 'lib/struct/icon/Icon';

const {
	'field': field_class,
	'field_with-hint': field_with_hint_class,
	'field-label': label_class,
	'field-label_indented': label_indented_class,
	'field-box': box_class,
	'field-box_flexible': box_flexible_class,
	'field-tag': tag_class,
	'field-tag--bottom': tag_class_bottom,
} = stylesTagField;

const {
	'price-fields': price_fields,
	'price-fields--no-margin': price_fields_no_margin,
	'price-fields-sign': price_fields_sign,
	'price-prop-field': price_prop_field,
	'add-price-field': add_price_field,
	'add-price-type-field': add_price_type_field,
	'add-price-fields-group': add_price_fields_group,
	'add-price-fields-group--wide': add_price_fields_group_wide,
	'add-price-fields-group--indent': add_price_fields_group_indent,
	'add-markup': add_markup,
} = styles;

@observer export default class TagSourceField extends Component {
	render() {
		const {
			markups,
			label,
			flexible_content,
			indent_label,
			hint,
			labelClass,
			contentClass,
			/** @type {Field} */
			field
		} = this.props
		const field_classes = [field_class]
		if (hint) {
			field_classes.push(field_with_hint_class)
		}

		const label_classes = [label_class]
		if (labelClass) {
			label_classes.push(labelClass)
		}

		const content_classes = [box_class]
		if (contentClass) {
			content_classes.push(contentClass)
		}

		if (flexible_content) {
			content_classes.push(box_flexible_class)
		}

		if (indent_label) {
			label_classes.push(label_indented_class)
		}

		return (
			<Fragment>
				<div className={field_classes.join(' ')}>
					<div className={label_classes.join(' ')}>
						{label}
					</div>
					<div className={content_classes.join(' ')}>
						{ markups.length > 0 ?
							markups.map((markup, index) => <div className={`${price_fields} ${price_fields_no_margin}`} key={index}>
								<div className={add_price_fields_group}>
									<div className={add_price_field}>
									<InputText
										value={markup.from.source_value}
										onChange={e => {
											if (e.target.value) {
												markup.from.source_value = e.target.value
												markup.from.source_type = SPECIFIC
											} else {
												markup.from.source_value = e.target.value
												markup.from.source_type = IS_EMPTY
											}
										}}
										placeholder="От"
										className={''}
									/>
								</div>
									<div className={price_fields_sign}>
										-
									</div>
									<div className={add_price_field}>
										<InputText
											value={markup.to.source_value}
											onChange={e => {
												if (e.target.value) {
													markup.to.source_value = e.target.value
													markup.to.source_type = SPECIFIC
												} else {
													markup.to.source_value = e.target.value
													markup.to.source_type = IS_EMPTY
												}
											}}
											placeholder="До"
											className={''}
										/>
									</div>
								</div>
								<div className={`${add_price_fields_group} ${add_price_fields_group_indent}`}>
									<div className={add_price_field}>
										<InputText
											value={markup.additional_price.source_value}
											onChange={e => {
												if (e.target.value) {
													markup.additional_price.source_value = e.target.value
													markup.additional_price.source_type = SPECIFIC
												} else {
													markup.additional_price.source_value = e.target.value
													markup.additional_price.source_type = IS_EMPTY
												}
											}}
											placeholder="0"
											className={''}
										/>
									</div>

									<div className={add_price_type_field}>
										<OfferFieldValueSourceSelect
											context={this.props.context}
											value_source={markup.additional_price_currency}
											field='ADDITIONAL_PRICE'
										/>
									</div>
								</div>
								<div className={add_price_fields_group}>
									<div className={price_fields_sign}>
										+
									</div>
									<div className={add_price_field}>
										<InputText
											value={markup.additional_price2.source_value}
											onChange={e => {
												if (e.target.value) {
													markup.additional_price2.source_value = e.target.value
													markup.additional_price2.source_type = SPECIFIC
												} else {
													markup.additional_price2.source_value = e.target.value
													markup.additional_price2.source_type = IS_EMPTY
												}
											}}
											placeholder="0"
											className={''}
										/>
									</div>
									<div className={add_price_type_field}>
										<OfferFieldValueSourceSelect
											context={this.props.context}
											value_source={markup.additional_price_currency2}
											field='ADDITIONAL_PRICE2'
										/>
									</div>
									<a
										onClick={() => {
											field.deleteMarkup(index)
										}}
									>
										<Icon name='close' />
									</a>
								</div>
							</div>) :
							<a
								onClick={() => {
									field.addMarkup()
								}}
							>
								<Icon name='add' /> <span style={{borderBottom: '1px dashed'}}>Добавить</span>
							</a>
						}
					</div>
					{markups.length > 0 &&
						<div className={`${tag_class} ${tag_class_bottom}`}>
							<a
								className={add_markup}
								onClick={() => {
									field.addMarkup()
								}}
							>
								<Icon name='add'/><span style={{borderBottom: '1px dashed'}}>Добавить</span>
							</a>
						</div>
					}
				</div>
			</Fragment>
		)
	}
}

TagSourceField.propTypes = {
	markups: PropTypes.any,
	label: PropTypes.any,
	flexible_content: PropTypes.any,
	indent_label: PropTypes.any,
	labelClass: PropTypes.any,
	contentClass: PropTypes.any,
};
